export default __webpack_public_path__ + "static/gallery-img6-3925d4aace4131aa3dca9c5f3c43ffec.jpg";